import { useAdminCourseStore } from '@/infrastructure/store/adminCourseStore';

export const useAdminCourses = () => {
  const store = useAdminCourseStore();
  return {
    courses: store.courses,
    isLoading: store.isLoading,
    uploadProgress: store.uploadProgress,
    error: store.error,
    fetchCourses: store.fetchCourses,
    createCourse: store.createCourse,
    updateCourse: store.updateCourse,
    deleteCourse: store.deleteCourse,
    removeCourseDocument: store.removeCourseDocument,
    clearError: store.clearError,
  };
};
